import { CurrencyAmount, JSBI, Token, Trade } from '@uniswap/sdk'
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import USDT from '../../assets/images/USDT.png'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default function Swap() {

    return (
        <>
            <div className="w-full flex flex-col h-full min-h-screen bg-[#1b1b1b] bg-contain bg-center bg-no-repeat">
                <div className="">
                    <Header />
                </div>

                <div className="w-full msm:pt-10 md:pt-0 md:flex md:flex-1 md:flex-col md:items-center md:justify-center bg-mobile bg-contain bg-top bg-no-repeat md:bg-none h-full pb-0" style={{ backgroundSize: '100%' }}>
                    <div className="flex items-center w-full text-lg text-[#0345ca] bg-top md:bg-center bg-no-repeat bg-[length:75%]">
                        <div className="px-[2.5rem] py-[2rem] w-[55rem] mx-auto">
                            <div className="h-full py-[12.5vh] space-y-8 pb-[10vh]">
                                <h1 className='text-6xl text-nowrap text-center'>
                                    Coming Soon
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

              
                <div className="">
                    <Footer />
                </div>
            </div>
        </>
    )
}
